/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ArrowBigUpFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M20.2929 14.1213C20.6834 14.5118 21.3166 14.5118 21.7071 14.1213C22.0976 13.7308 22.0976 13.0976 21.7071 12.7071L12 3L2.29289 12.7071C1.90237 13.0976 1.90237 13.7308 2.29289 14.1213C2.68342 14.5118 3.31658 14.5118 3.70711 14.1213L11 6.82843L11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20L13 6.82843L20.2929 14.1213Z" />
      </svg>
    </Icon>
  );
});

export { ArrowBigUpFillIcon };
